import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllSlideShow } from "../../service/Slide";
import { apiUrl } from "../../config";

const Slide = () => {
    const [slides, setSlides] = useState([]);

    useEffect(() => {
        const loadSlides = async () => {
            try {
                const data = await fetchAllSlideShow();
                setSlides(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error fetching slides:", err);
                setSlides([]); // fallback
            }
        };
        loadSlides();
    }, []);

    const hasSlides = slides.length > 0;

    return (
        <>
            <div className="container-fluid banner-marquee-container">
                <div className="row marquee-row">
                    <marquee
                        className="marquee-announcement-home-page"
                        behavior="scroll"
                        direction="left"
                        scrollamount="8"
                    >
                        <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                            <span role="img" aria-label="announcement" className="fs-5 me-2">
                                📢
                            </span>
                            <span className="fw-bold ">
                                This web VVRHCS has many Healthcare sites to register your name
                                and company please contact us :
                                <a
                                    href="#"
                                    style={{
                                        textDecoration: "none",
                                        color: "#ffffff",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <span>
                                        <i className="fas fa-phone me-2"></i>
                                    </span>
                                    04362 - 238 235
                                </a>
                            </span>
                        </div>
                    </marquee>
                </div>
            </div>
            <div className="">
                {hasSlides ? (
                    /* ✅ Carousel only if slides exist */
                    <div
                        id="homeSlideCarousel"
                        className="carousel slide"
                        data-bs-ride="carousel"
                    >
                        <div className="carousel-inner">
                            {slides.map((slide, index) => {
                                const isActive = index === 0 ? " active" : "";
                                const bgGradient =
                                    slide.bgColor1 && slide.bgColor2
                                        ? `linear-gradient(135deg, ${slide.bgColor1}, ${slide.bgColor2})`
                                        : "#f8f9fa";

                                return (
                                    <div className={`carousel-item${isActive}`} key={slide.id}>
                                        <div
                                            className="d-flex flex-row align-items-center justify-content-center text-start"
                                            style={{
                                                background: bgGradient,
                                                height: "500px",
                                                overflow: "hidden",
                                                gap: "30px"
                                            }}
                                        >
                                            {slide.imageUrl && (
                                                <img
                                                    src={
                                                        typeof slide.imageUrl === "string"
                                                            ? slide.imageUrl.startsWith("http")
                                                                ? slide.imageUrl
                                                                : `${apiUrl}/${slide.imageUrl}`
                                                            : URL.createObjectURL(slide.imageUrl)
                                                    }
                                                    alt={slide.title}
                                                    className="shadow"
                                                    style={{
                                                        height: "450px",
                                                        width: "450px",
                                                        objectFit: "fit",
                                                        borderRadius: "12px",
                                                        border: "3px solid #fff",
                                                    }}
                                                />
                                            )}


                                            {/* Text Section */}
                                            <div className="d-flex flex-column justify-content-center" style={{ maxWidth: "50%" }}>
                                                <h1 className="fw-bold" style={{ color: slide.titleColor || "#000" }}>
                                                    {slide.title}
                                                </h1>
                                                {slide.name && (
                                                    <h2
                                                        className="fw-bold"
                                                        style={{ color: slide.nameColor || "#333" }}
                                                    >
                                                        {slide.name}
                                                    </h2>
                                                )}
                                                {slide.description && (
                                                    <h3 style={{ color: slide.descriptionColor || "#666" }}>
                                                        {slide.description}
                                                    </h3>
                                                )}
                                                {slide.linkUrl && (
                                                    <div className="text-end mt-3">
                                                        <a
                                                            href={slide.linkUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-info text-white fw-bold"
                                                        >
                                                            View More
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Controls */}
                        <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target="#homeSlideCarousel"
                            data-bs-slide="prev"
                        >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target="#homeSlideCarousel"
                            data-bs-slide="next"
                        >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>

                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        </>
    );
};

export default Slide;
